import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/drupal': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M319.5 114.7c13.5 8.3 96.5 67 96.5 179.3 0 112-88.5 186-190.2 186-102 0-193.8-80.3-193.8-189.5 0-109 85-167.5 100.8-175.8 18.7-10.1 32.2-15.3 53.5-32.3 10.5-8.3 19.3-20.2 22-49.5 15.2 18.3 33.5 39.5 46.5 48.3 21.2 14 42.5 19.5 64.7 33.5zM322 440.3c4.2-4.2 1.9-13.1-4.2-8.5-8.5 6.3-27.5 14-54.5 14-34.5 0-51.5-13.3-51.5-13.3-6.2 0-11.3 7.2-6.5 12 26.6 24.5 96.6 15.9 116.7-4.2zM267.5 387.7c-6.5 2.7-28.4 16.8-22.4 25 2.4 3.3 5.2 1.3 12.2-4.7 7.2-5.8 12-11 26.7-11 25.3 0 18.1 19.9 26.5 15.7 9.9-4.9-2.1-20.9-6.2-23.7-7.8-5.1-28.1-4.9-36.8-1.3zM360 405c39.1 3.3 64.5-106 15.8-106-20 0-60.5 41.5-81.8 41.8-24.7 0.5-59-49-108.5-48.5-66.4 0.4-90.6 78.6-51.8 105.2 57.2 38.7 130.4-42.9 161.3-42 19.5 0.7 49.8 48.5 65 49.5z'
      }
    ]
  }
})
